<template>
  <div v-if="isChatbotEnabled && chatbotApiKey" ref="widgetContainer"></div>
</template>

<script>
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "ChatbotWidget",
  props: {
    isChatbotEnabled: {
      type: Boolean,
      default: false
    },
    chatbotApiKey: {
      type: String,
      default: ""
    },
    chatbotTitle: {
      type: String,
      default: "Chat Assistant"
    }
  },
  watch: {
    chatbotApiKey() {
      this.renderWidget();
    },
    isChatbotEnabled() {
      this.renderWidget();
    },
    chatbotTitle() {
      this.renderWidget();
    }
  },
  mounted() {
    this.renderWidget();
  },
  beforeDestroy() {
    this.removeWidgetElement();
  },
  methods: {
    async renderWidget() {
      if (!this.isChatbotEnabled || !this.chatbotApiKey) {
        this.removeWidgetElement();
        return;
      }

      await this.ensureWidgetScript();
      this.$nextTick(() => {
        this.removeWidgetElement();
        const container = this.$refs.widgetContainer;
        if (!container) {
          return;
        }

        // Important: this widget reads attributes in its constructor.
        // Therefore we inject full markup so attributes exist at creation time.
        container.innerHTML = `
          <eo-chatbot-widget
            data-api-url="${env.prompts_api_client_url}"
            data-api-key="${this.chatbotApiKey}"
            data-title="${this.chatbotTitle || "Chat Assistant"}"
            data-position="bottom-right"
            data-offset-x="24px"
            data-offset-y="74px"
            style="--eo-chatbot-primary:#00636c;--eo-chatbot-user-bg:#00636c;--eo-chatbot-primary-hover:#00555d;"
          ></eo-chatbot-widget>
        `;
      });
    },
    removeWidgetElement() {
      const container = this.$refs.widgetContainer;
      if (!container) {
        return;
      }
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    },
    ensureWidgetScript() {
      return new Promise(resolve => {
        const existingScript = document.getElementById(
          "eo-chatbot-widget-script"
        );
        if (existingScript) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.id = "eo-chatbot-widget-script";
        script.type = "module";
        script.src =
          "https://eo-chatbot-widget-test.web11.oya-media.cloud/eo-chatbot-widget.js";
        script.onload = () => resolve();
        script.onerror = () => {
          console.error("Failed to load eo-chatbot-widget.js");
          resolve();
        };
        document.body.appendChild(script);
      });
    }
  }
};
</script>

<style scoped>
/* Widget stylt sich selbst */
</style>
